import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IBaseMccField {
	useCustomerMcc: boolean;
	changeBaseMcc: (value: Nullable<number>) => void;
}

const BaseMccField: React.FC<IBaseMccField> = ({ useCustomerMcc, changeBaseMcc }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [{ required: !useCustomerMcc, message: t('enterBaseMcc') }],
		[t, useCustomerMcc],
	);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeBaseMcc(value);
		},
		[changeBaseMcc],
	);

	return (
		<FormInput
			testId="BaseMccField"
			type="number"
			min={1000}
			max={9999}
			name="baseMcc"
			label="baseMccLabel"
			disabled={useCustomerMcc}
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(BaseMccField);
